export const environment = {
  production: true,
  envName: 'prd',
  spa: {
    baseUrl: '/webapps',
    app: {
      cache: '/cache',
      res: '/reservation',
      srv: '/servicing',
      exc: '/exchange',
      cki: '/checkin',
    },
  },
  api: {
    baseUrl: 'https://space.ana.co.jp',
    clientId: 'd4c2573f131a4a0980ecfd0404f69301',
    clientSecret: '9c63b2aFDafb477285439F03247C4f08',
    app: {
      sysdate: '/all-orc-sysdate/api/v1',
      authorization: '/all-orc-authorization/api/v1',
      initialization: '/all-orc-initialization/api/v1',
      user: '/all-orc-user/api/v1',
      amcmember: '',
      search: '/all-orc-search/api/v1',
      reservation: '/all-orc-reservation/api/v1',
      servicing: '/all-orc-servicing/api/v1',
      exchange: '/all-orc-exchange/api/v1',
      checkin: '/all-orc-checkin/api/v1',
      member: '',
      credit: '',
    },
  },
  datadog: {
    disable: false,
    env: 'prd',
    clientToken: 'pub71ef99b3ce6dfa6584aae68f6452919e',
    versionFileRelativeUrl: '',
  },
  tealium: {
    disable: true,
    url: '',
  },
  dynatrace: {
    res: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/702cd97f8c90206d_complete.js',
    },
    srv: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/28e874cd4db184b5_complete.js',
    },
    exc: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/f1fbe9fbf8cce33_complete.js',
    },
    cki: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/8d00e6ae345aa3af_complete.js',
    },
  },
};
